"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BeautyPoints = require("./BeautyPoints");
Object.keys(_BeautyPoints).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BeautyPoints[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BeautyPoints[key];
    }
  });
});
